<template>
  <div v-if="products && links" class="data_field">
    <table style="width: 100%" v-if="products.length !== 0" cellpadding="0" cellspacing="0" class="table">
      <thead>
      <tr>
        <th style="width: 100px">Наименование</th>
        <th>Питание, В</th>
        <th>БП, А</th>
        <th>Входы</th>
        <th>Выходы</th>
        <th>Интерфейсы</th>
      </tr>
      </thead>
      <tr v-for="row in products" :key="row.code">
        <td style="width: 250px">
          <p class="f_label">
            <a target="_blank" :href="getLink(row.label)">{{ row.label }}</a>
          </p>
          <p v-html="row.descr"></p>
          <div class="data__name">
            <div class="s_col">
              <p class="price">{{ setPrice(row.vat_price) }},<span>00</span> ₽</p>
              <p v-if="getLocation()">
                <a @click="addToCart (row.label)"
                   :data-code="row.code"
                   :data-id="row.code"
                   :data-name="row.label"
                   data-qty="1"
                   :data-price="row.vat_price"
                   :data-price_text="row.vat_price + ',<span class=kopeck>00</span>'"
                   title="Добавить в корзину"
                   class="product-card__button j-product-prices-order-button">Купить</a>
              </p>
            </div>
          </div>
        </td>
        <td><span v-html="row.params[0]"></span></td>
        <td>{{ row.params[1] }}</td>
        <td>
          <p :class="{disabled: !row.params[2]}">
            <b>Всего: </b>{{ row.params[2] }}
          </p>
          <p :class="{disabled: !row.params[3]}">
            <b>DI: </b>{{ row.params[3] }}
          </p>
          <p :class="{disabled: !row.params[4]}">
            <b>AI: </b>{{ row.params[4] }}
          </p>
        </td>
        <td>
          <p :class="{disabled: !row.params[5]}">
            <b>Всего: </b>{{ row.params[5] }}
          </p>
          <p :class="{disabled: !row.params[6]}">
            <b>DO: </b>{{ row.params[6] }}
          </p>
          <p :class="{disabled: !row.params[7]}">
            <b>AO: </b>{{ row.params[7] }}
          </p>
        </td>
        <td>
          <div class="data__interfaces">
            <div class="f_col">
              <p :class="{disabled: !row.params[8]}">
                <b>SPI: </b>{{ row.params[8] }}
              </p>
              <p :class="{disabled: !row.params[9]}">
                <b>RS-485: </b>{{ row.params[9] }}
              </p>
              <p :class="{disabled: !row.params[10]}">
                <b>RS-422: </b>{{ row.params[10] }}
              </p>
              <p :class="{disabled: !row.params[11]}">
                <b>RS-232: </b>{{ row.params[11] }}
              </p>
              <p :class="{disabled: !row.params[12]}">
                <b>Ethernet: </b>{{ row.params[12] }}
              </p>
              <p :class="{disabled: !row.params[13]}">
                <b>Ethercat: </b>{{ row.params[13] }}
              </p>
            </div>
            <div class="s_col">
              <p :class="{disabled: !row.params[14]}">
                <b>Ethernet daisy chain: </b>{{ row.params[14] }}
              </p>
              <p :class="{disabled: !row.params[15]}">
                <b>GSM 2G: </b>{{ row.params[15] }}
              </p>
              <p :class="{disabled: !row.params[16]}">
                <b>GSM LTE: </b>{{ row.params[16] }}
              </p>
              <p :class="{disabled: !row.params[17]}">
                <b>WiFi: </b>{{ row.params[17] }}
              </p>
              <p :class="{disabled: !row.params[18]}">
                <b>Оптика: </b>{{ row.params[18] }}
              </p>
              <p :class="{disabled: !row.params[19]}">
                <b>NFC: </b>{{ row.params[19] }}
              </p>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import goals from '../../goals'

export default {
  name: "TableData",
  props: ['products', 'links'],
  methods: {
    getLocation()
    {
      return window.location.hash !== '#frame'
    },
    getLink(name)
    {
      return this.links[name]
    },
    setPrice(price)
    {
      return Intl.NumberFormat("ru-RU").format(price);
    },
    addToCart(item)
    {
      console.log()
      if (process.env.NODE_ENV === 'production')
      {
        goals.addToCart(item)
      }
    },
  },
}
</script>

<style scoped>

.f_label a {
  font-size: 16px;
  color: #008f86;
}

td > * {
  margin-bottom: 5px !important;
}

.disabled {
  display: none;
}

.table,
.table td,
.table th {
  border: solid 1px silver;
  padding: 10px;
}

.price {
  font-weight: 500;
  margin-bottom: 5px !important;
  font-size: 14px !important;
}

.table {
  color: #4c4c4c;
  border-collapse: collapse;
  text-align: left;
}


.table thead {
  background-color: #ededed;
}

.table p {
  margin: 0;
  padding: 0;
  font-size: 12px;
  line-height: normal;
}

.table td:first-child {
  width: 25%;
}

.product-card__button {
  float: none !important;
}

@media screen and (max-width: 550px) {
  .data_field {
    overflow: scroll;
  }
}

</style>